function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_12904",
  width: 24,
  height: 24,
  fill: "#fff"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_67445",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_146188",
  d: "M14.188,18.532V14.645l3.33,1.921a1.447,1.447,0,0,0,.716.264c.3,0,.535-.211.836-.671l.113-.188a1.415,1.415,0,0,0,.279-.738c0-.331-.241-.573-.693-.829L15.3,12.415l3.458-1.891c.452-.249.67-.49.67-.814a1.6,1.6,0,0,0-.256-.738l-.121-.2c-.271-.467-.512-.678-.829-.678a1.5,1.5,0,0,0-.716.256l-3.322,1.929L14.2,6.411c0-.881-.309-1.115-1.19-1.115h-.218c-.889,0-1.19.234-1.19,1.115l.008,3.865L8.282,8.347a1.581,1.581,0,0,0-.761-.271c-.316,0-.58.2-.814.693L6.6,8.957a1.916,1.916,0,0,0-.226.753c0,.331.211.557.663.821l3.443,1.883L7.024,14.4c-.444.256-.67.49-.67.806a1.553,1.553,0,0,0,.271.761l.105.181c.264.467.512.686.829.686a1.554,1.554,0,0,0,.716-.264l3.33-1.929L11.6,18.532c0,.881.3,1.115,1.19,1.115h.218C13.887,19.647,14.2,19.414,14.188,18.532Z",
  transform: "translate(-0.908 -0.757)"
}));

function SvgAsterisk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsterisk);
export default __webpack_public_path__ + "static/media/asterisk.f43179ce.svg";
export { ForwardRef as ReactComponent };